'use client'
import {
  useUi
} from "./chunk-Y3GT52GT.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Image/ImageWithFallback.tsx
import { jsx } from "react/jsx-runtime";
var ImageWithFallback = (_a) => {
  var _b = _a, { fallbackSrc, ref } = _b, props = __objRest(_b, ["fallbackSrc", "ref"]);
  return /* @__PURE__ */ jsx(
    "img",
    __spreadProps(__spreadValues({}, props), {
      ref,
      src: props.src || fallbackSrc || "/images/default-poster_1x1.png",
      alt: props.alt || "",
      onError: (e) => {
        e.currentTarget.srcset = "";
        e.currentTarget.src = fallbackSrc || "/images/default-poster_1x1.png";
        e.currentTarget.style.removeProperty("background");
      }
    })
  );
};
var ImageWithFallback_default = ImageWithFallback;

// src/Image/ImageWithPlaceholder.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ImageWithPlaceholder = (_a) => {
  var _b = _a, { width, height, alt, loaderSrc, ratio } = _b, rest = __objRest(_b, ["width", "height", "alt", "loaderSrc", "ratio"]);
  const { imgFallbacks } = useUi();
  const safeWidth = width || 800;
  const safeHeight = height || 800;
  const initialSrc = ratio === "3x1" ? imgFallbacks == null ? void 0 : imgFallbacks["3x1"] : imgFallbacks == null ? void 0 : imgFallbacks["1x1"];
  return /* @__PURE__ */ jsx2(
    ImageWithFallback_default,
    __spreadProps(__spreadValues({
      loading: "lazy"
    }, rest), {
      fallbackSrc: loaderSrc || initialSrc,
      width: safeWidth,
      height: safeHeight,
      alt,
      style: __spreadValues({
        background: `center / cover no-repeat url(${loaderSrc || initialSrc})`
      }, rest.style),
      onLoad: (e) => {
        var _a2;
        e.currentTarget.style.removeProperty("background");
        (_a2 = rest.onLoad) == null ? void 0 : _a2.call(rest, e);
      }
    })
  );
};
var ImageWithPlaceholder_default = ImageWithPlaceholder;

export {
  ImageWithFallback_default,
  ImageWithPlaceholder_default
};
//# sourceMappingURL=chunk-VPIMEK75.mjs.map